import React, { useEffect, createElement } from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export function HeroSection() {
  useEffect(() => {
    // Preload the LCP image for better performance
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = 'https://cdn.magicpatterns.com/uploads/r9a6Xy86W3oqs1XmyDrfyC/biologia_box_mobile_768.webp';
    link.imageSrcset = 'https://cdn.magicpatterns.com/uploads/r9a6Xy86W3oqs1XmyDrfyC/biologia_box_mobile_768.webp 768w';
    link.fetchPriority = 'high';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);
  return <section className="pt-24 md:pt-32 pb-10 md:pb-16 px-4 bg-white text-center" data-id="element-155">
      <div className="max-w-4xl mx-auto" data-id="element-156">
        {/* Reserved space for title to prevent CLS */}
        <div className="min-h-[80px] md:min-h-[120px] flex items-center justify-center mb-2" data-id="element-157">
          <h1 className="text-3xl md:text-5xl font-black text-brand-dark leading-tight tracking-tight" data-id="element-158">
            Todo tu año de Biología <br className="hidden md:block" data-id="element-159" />
            <span className="text-brand-blue underline decoration-brand-orange decoration-4 md:decoration-8 underline-offset-4 md:underline-offset-8" data-id="element-160">
              resuelto.
            </span>
          </h1>
        </div>

        {/* Reserved space for hero image to prevent CLS */}
        <div className="relative w-11/12 max-w-lg md:max-w-2xl mx-auto mb-5 md:mb-8 aspect-[3/4] md:aspect-[4/5]" data-id="element-161">
          <a href="#compra" className="block cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" data-id="element-162">
            <picture data-id="element-163">
              <source media="(max-width: 767px)" srcSet="https://cdn.magicpatterns.com/uploads/r9a6Xy86W3oqs1XmyDrfyC/biologia_box_mobile_768.webp" type="image/webp" data-id="element-164" />
              <source media="(min-width: 768px)" srcSet="https://cdn.magicpatterns.com/uploads/r9a6Xy86W3oqs1XmyDrfyC/biologia_box_mobile_768.webp" type="image/webp" data-id="element-165" />
              <img data-id="element-161" src="https://cdn.magicpatterns.com/uploads/r9a6Xy86W3oqs1XmyDrfyC/biologia_box_mobile_768.webp" alt="MegaPack Biología en Acción" width={768} height={1024} fetchPriority="high" loading="eager" className="w-full h-auto drop-shadow-2xl rounded-xl object-contain" />
            </picture>
          </a>
        </div>

        {/* Payment Security Section */}

        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4" data-id="element-166">
          BIOLOGÍA EN ACCIÓN — 6 Tomos + 3 Bonos + Sistema VIP
        </h2>

        <p className="text-xl md:text-2xl italic text-gray-600 font-medium mb-5 md:mb-8" data-id="element-167">
          "Planificación total. De 1° a 6° año."
        </p>

        <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto mb-6 md:mb-10 leading-relaxed" data-id="element-168">
          El sistema que usan cientos de profesores de Biología de secundaria en
          Argentina para organizar sus clases de todo el ciclo básico y superior
          en una tarde — sin improvisar, sin buscar en Google y recuperando sus
          domingos.
        </p>

        <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-6 md:mb-8" data-id="element-169">
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-170">
            📄 100% PDF
          </span>
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-171">
            ⚡ Acceso inmediato
          </span>
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-172">
            🇦🇷 Currículo argentino (PBA + NAP)
          </span>
        </div>

        <div className="max-w-2xl mx-auto mb-5" data-id="element-173">
          <CTAButton text="🧬 → QUIERO MI MEGAPACK AHORA" href="#compra" isLink={true} data-id="element-174" />
        </div>

        <div className="max-w-xl mx-auto text-left text-xs md:text-sm text-gray-600 space-y-0.5 mb-5" data-id="element-175">
          <p data-id="element-176">🔒 Tu pago es 100% seguro</p>
          <p data-id="element-177">✅ No necesitás tener cuenta en Mercado Pago</p>
          <p data-id="element-178">✅ Podés pagar con tarjeta de débito o crédito</p>
          <p data-id="element-179">✅ También aceptamos transferencia bancaria o CVU</p>
          <p data-id="element-180">✅ Tus datos están protegidos en todo momento</p>
          <p data-id="element-181">📩 En menos de 5 minutos recibís todo en tu email</p>
          <p data-id="element-182">⚠️ Si no lo ves, revisá Spam o Promociones</p>
        </div>

        <div className="flex justify-center mb-4" data-id="element-183">
          <img src="https://cdn.magicpatterns.com/uploads/5ZHwy7pq4xWzkYyw4KPizC/jo3l6snt.png" alt="Garantía 7 días de reembolso" className="h-16 w-16 md:h-20 md:w-20" data-id="element-184" />
        </div>
      </div>
    </section>;
}